import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { Link } from 'react-router-dom';
import { letterheadAPI } from '../../services/api';
import Topbar from "../../components/Topbar";

const ACCENTS = { Modern:'#1a5276', Classic:'#1e8449', PSE:'#7d6608' };

function LetterheadTemplates() {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    letterheadAPI.listTemplates()
      .then(d => setTemplates(d.templates || []))
      .catch(() => setTemplates([
        { _id:'t1', name:'Modern', description:'Clean modern design with gradient header', isActive:true },
        { _id:'t2', name:'Classic', description:'Traditional professional format', isActive:true },
        { _id:'t3', name:'PSE', description:'Government standard format', isActive:true },
      ]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Header/>
      <div id="db-wrapper"><main id="page-content">
          <Topbar section="Letterhead" /><section className="container-fluid p-4 pt-3">
        <div className="page-hero d-flex align-items-center justify-content-between flex-wrap gap-2">
          <div>
            <h5 className="text-white lh-1">Letterhead Templates</h5>
            <div className="sub">Step 2 — Select a template to generate your official TSE letterhead</div>
          </div>
          <Link to="/letterhead/editor" className="btn fw-semibold px-4 py-2" style={{background:'rgba(255,255,255,0.2)',color:'#fff',borderRadius:10,border:'1.5px solid rgba(255,255,255,0.35)'}}>
            <i className="bi bi-plus-circle me-2"/>New Letterhead
          </Link>
        </div>

        {loading ? <div className="text-center py-5"><span className="spinner-border text-primary"/></div> : (
          <div className="row g-2">
            {templates.map(t => {
              const accent = ACCENTS[t.name] || '#1a5276';
              return (
                <div key={t._id} className="col-12 col-sm-6 col-lg-4">
                  <div className="kpi-card p-2 h-100" style={{cursor:t.isActive?'pointer':'default',opacity:t.isActive?1:0.55,border:selected===t._id?'2px solid #4f6ef7':'1px solid #eef0f6',transition:'all 0.15s',padding:0,overflow:'hidden'}} onClick={()=>t.isActive&&setSelected(t._id)}>
                    <div className="rounded-4" style={{background:accent,padding:'10px 11px',position:'relative'}}>
                      <div style={{color:'#fff',fontWeight:700,fontSize:'0.754rem'}}>TSE ENVIRONMENT</div>
                      <div style={{color:'rgba(255,255,255,0.75)',fontSize:'0.57rem',marginBottom:8}}>Official Letterhead</div>
                      <div style={{background:'rgba(255,255,255,0.15)',borderRadius:6,padding:'7px 14px'}}>
                        <div style={{color:'#fff',fontWeight:700,fontSize:'0.718rem'}}>Mr. Rajesh Kumar</div>
                        <div style={{color:'rgba(255,255,255,0.7)',fontSize:'0.57rem'}}>Manager, Workspace Dept.</div>
                        <div style={{borderTop:'1px solid rgba(255,255,255,0.3)',marginTop:6,paddingTop:4,fontSize:'0.534rem',color:'rgba(255,255,255,0.65)'}}>Ref No.: TSE/LET/2025-26/125</div>
                      </div>
                      {selected===t._id&&<div style={{position:'absolute',top:10,right:10,background:'#fff',borderRadius:'50%',width:22,height:22,display:'flex',alignItems:'center',justifyContent:'center'}}><i className="bi bi-check-circle-fill" style={{color:'#4f6ef7',fontSize:'0.782rem'}}/></div>}
                    </div>
                    <div style={{padding:'10px 11px'}}>
                      <div style={{fontWeight:700,fontSize:'0.828rem',color:'#111827',marginBottom:3}}>{t.name} Template</div>
                      <div style={{fontSize:'0.7rem',color:'#9ca3af',marginBottom:8}}>{t.description}</div>
                      {t.isActive
                        ? <Link to={`/letterhead/editor?template=${t._id}&name=${t.name}`} className="btn w-100 rounded-3 fw-semibold" style={{background:'#eff6ff',color:'#1d4ed8',border:'none',fontSize:'0.718rem'}}>Use Template</Link>
                        : <div className="btn w-100 rounded-3 disabled" style={{background:'#f3f4f6',color:'#9ca3af',fontSize:'0.718rem'}}>Not Available</div>
                      }
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {selected && (
          <div className="d-flex justify-content-end mt-3">
            <Link to={`/letterhead/editor?template=${selected}`} className="btn fw-semibold px-5 py-2"
              style={{background:'linear-gradient(135deg,#1a5276,#1e8449)',color:'#fff',borderRadius:12,border:'none',fontSize:'0.828rem'}}>
              <i className="bi bi-pencil-square me-2"/>Proceed to Fill Details
            </Link>
          </div>
        )}
      </section></main></div>
    </>
  );
}
export default LetterheadTemplates;
